// KONTRAK lintas-layar (pemilik: kelompok "nota-rute"). Signature tetap.
// v1: A.openNota(id), A.deliverModal(n, items), A.failModal(n) di public/js/ops.js.
import { api } from '../../lib/api.js';
import { useNotaOps } from './ops.js';
import type { NotaDetail } from './types.js';

/** Buka detail nota (modal) berdasarkan id. Dipakai Beranda, Rute, pencarian global, Operasi. */
export function useOpenNota(): (id: number) => Promise<void> {
  const { openNota } = useNotaOps();
  return openNota;
}

/**
 * Modal serah terima barang & pembayaran (dipakai layar driver "tugas" & admin).
 * onDone dipanggil setelah sukses (tanpa onDone: halaman aktif dimuat ulang, sama dengan A.render() v1).
 */
export function useDeliverModal(): (notaId: number, onDone?: () => void) => Promise<void> {
  const { deliverWith } = useNotaOps();
  return async (notaId, onDone) => {
    const d = await api<NotaDetail>('GET', `/api/notas/${notaId}`);
    deliverWith(d.item, d.items, onDone);
  };
}

/** Modal gagal kirim (dipakai layar driver & admin). onDone sama seperti useDeliverModal. */
export function useFailModal(): (notaId: number, onDone?: () => void) => Promise<void> {
  const { failWith } = useNotaOps();
  return async (notaId, onDone) => {
    const d = await api<NotaDetail>('GET', `/api/notas/${notaId}`);
    failWith(d.item, onDone);
  };
}
